import _ from 'lodash';
import { SubmissionError } from 'redux-form';
import mfa from '../../../Services/mfa';

export default async (values, dispatch, props) => {

  const { config } = props;

  const data = {
    otp: values.mfa1 + values.mfa2 + values.mfa3 + values.mfa4,
  }

  try {

    await dispatch(mfa(data));

  } catch (error) {

    if (_.has(error,'response.status') && error.response.status === 401) {
      throw new SubmissionError({
        _error: 'Error: That one time passcode is not valid.'
      })
    } else {
      throw new SubmissionError({
        _error: 'Error: There seems to be a problem behind the scenes ...'
      })
    }

  }

}

